import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import BookingCalendar from '../../components/feature/BookingCalendar';

export default function PolizzaMorositaPage() {
  const [showBooking, setShowBooking] = useState(false);
  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/');
    setTimeout(() => {
      const element = document.getElementById('contatti');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-red-50 to-orange-100 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-fill text-3xl text-white"></i>
              </div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Polizza Assicurativa Morosità
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
               Proteggi il tuo investimento immobiliare con una copertura completa contro 
                inquilini morosi, danni all'immobile e spese legali di sfratto.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Button size="lg" className="cursor-pointer whitespace-nowrap" onClick={() => setShowBooking(true)}>
                  <span className="flex items-center">
                    <i className="ri-calendar-check-fill mr-2"></i>
                    Prenota Videoconferenza Gratuita 
                  </span>
                </Button>
                <Button 
                  variant="outline" 
                  size="lg" 
                  className="cursor-pointer whitespace-nowrap"
                  onClick={() => {
                    document.getElementById('coperture')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                >
                  <span className="flex items-center">
                    <i className="ri-information-fill mr-2"></i>
                    Scopri le Coperture
                  </span>
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Coperture Principali */}
        <section id="coperture" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Cosa Copre la Polizza
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Una protezione completa per tutelare il proprietario da ogni rischio legato alla locazione
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Affitti Non Pagati */}
              <div className="bg-gradient-to-br from-red-50 to-white rounded-xl p-8 border-2 border-red-200 shadow-lg">
                <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-money-euro-circle-fill text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Affitti Non Pagati
                </h3>
                <div className="text-4xl font-bold text-red-600 mb-4">
                  12 Mesi
                </div>
                <p className="text-gray-600">
                  Copertura fino a 12 mensilità di canone non pagato dall'inquilino moroso. 
                  La polizza rimborsa il proprietario garantendo continuità di reddito.
                </p>
              </div>

              {/* Danni all'Immobile */}
              <div className="bg-gradient-to-br from-orange-50 to-white rounded-xl p-8 border-2 border-orange-200 shadow-lg">
                <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-home-gear-fill text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Danni e Spese
                </h3>
                <div className="text-4xl font-bold text-orange-600 mb-4">
                  3 Mesi
                </div>
                <p className="text-gray-600">
                  Copertura fino a 3 mensilità di canone per danni arrecati all'immobile, 
                  ai beni mobili e spese condominiali non pagate.
                </p>
              </div>

              {/* Spese Legali */}
              <div className="bg-gradient-to-br from-yellow-50 to-white rounded-xl p-8 border-2 border-yellow-200 shadow-lg">
                <div className="w-16 h-16 bg-yellow-600 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-scales-3-fill text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Spese Legali 
                </h3>
                <div className="text-4xl font-bold text-yellow-600 mb-4">
                  €2.000
                </div>
                <p className="text-gray-600">
                  Copertura fino a €2.000 per tutte le spese legali relative alle 
                  procedure di sfratto per morosità dell'inquilino.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Come Funziona */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Come Funziona
              </h2>
              <p className="text-xl text-gray-600">
                Attiva la tua protezione in 4 semplici passaggi
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-video-chat-line text-3xl text-blue-600"></i>
                </div>
                <div className="bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-lg">
                  1
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Contattami
                </h3>
                <p className="text-gray-600">
                  Collegati in videoconferenza per avere maggiori informazioni sulle coperture. Se lo desideri, possiamo iniziare ad acquisire le informazioni necessarie per procedere al passo successivo.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-user-search-line text-3xl text-blue-600"></i>
                </div>
                <div className="bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-lg">
                  2
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Valutazione Inquilino
                </h3>
                <p className="text-gray-600">
                  Valutazione se l'inquilino è assicurabile, risposta entro 48 ore
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-file-text-line text-3xl text-blue-600"></i>
                </div>
                <div className="bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-lg">
                  3
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Firma e Pagamento
                </h3>
                <p className="text-gray-600">
                  Firma il contratto e paga il premio assicurativo
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-shield-check-line text-3xl text-green-600"></i>
                </div>
                <div className="bg-blue-600 text-white w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-4 font-bold text-lg">
                  4
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  Protezione Attiva
                </h3>
                <p className="text-gray-600">
                  La tua polizza è attiva e sei protetto da morosità e danni fino alla prima scadenza contrattuale!
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Documenti Necessari per la Valutazione */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Documenti Necessari per la Valutazione
              </h2>
              <p className="text-xl text-gray-600">
                Per valutare se l'inquilino è assicurabile, sono necessari i seguenti documenti
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 md:p-12 shadow-xl border-2 border-blue-200">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="bg-white rounded-xl p-6 shadow-md text-center">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-id-card-fill text-3xl text-blue-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    Carta d'Identità
                  </h3>
                  <p className="text-gray-600">
                    Documento di identità dell'inquilino, <strong>fronte e retro</strong>, in corso di validità
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-md text-center">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-bank-card-fill text-3xl text-green-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    Codice Fiscale
                  </h3>
                  <p className="text-gray-600">
                    Tessera sanitaria o documento equivalente con il <strong>codice fiscale</strong> dell'inquilino
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-md text-center">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-file-list-3-fill text-3xl text-orange-600"></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    Ultime 3 Buste Paga
                  </h3>
                  <p className="text-gray-600">
                    Le <strong>ultime 3 buste paga</strong> dell'inquilino per verificare la capacità reddituale
                  </p>
                </div>
              </div>

              <div className="mt-8 bg-yellow-50 border border-yellow-300 rounded-xl p-6">
                <div className="flex items-start">
                  <i className="ri-information-fill text-yellow-600 text-2xl mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Nota Importante</h4>
                    <p className="text-gray-700">
                      I documenti devono essere forniti durante la videoconferenza o inviati successivamente. 
                      La valutazione dell'assicurabilità dell'inquilino viene completata entro <strong>48 ore</strong> dalla ricezione di tutta la documentazione.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Prezzo Polizza */}
        <section className="py-20 bg-white">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Quanto Costa la Polizza?
              </h2>
              <p className="text-xl text-gray-600">
                Un investimento minimo per una protezione massima
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl p-8 md:p-12 shadow-xl">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                <div>
                  <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center mb-6">
                    <i className="ri-price-tag-3-fill text-4xl text-white"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">
                    Circa 1 Mensilità di Affitto
                  </h3>
                  <p className="text-lg text-gray-700 mb-6">
                    Il costo della polizza corrisponde all'incirca a una mensilità di affitto. 
                    Si paga un'unica volta e l'assicurazione copre fino alla prima scadenza del contratto di locazione.
                  </p>
                  <div className="bg-white rounded-xl p-6 shadow-md">
                    <div className="flex items-start mb-4">
                      <i className="ri-information-fill text-blue-600 text-2xl mr-3 mt-1"></i>
                      <div>
                        <h4 className="font-bold text-gray-900 mb-2">Esempio Pratico</h4>
                        <p className="text-gray-600">
                          Se il contratto è un <strong>4+4</strong>, la polizza copre i <strong>primi 4 anni</strong> con un unico premio. 
                          Nessun rinnovo annuale, nessuna sorpresa.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="bg-white rounded-xl p-6 shadow-md">
                    <div className="flex items-center mb-3">
                      <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                        <i className="ri-check-double-fill text-2xl text-green-600"></i>
                      </div>
                      <h4 className="text-lg font-bold text-gray-900">Pagamento Unico</h4>
                    </div>
                    <p className="text-gray-600">
                      Paghi una sola volta all'inizio del contratto, senza rate mensili o costi nascosti.
                    </p>
                  </div>

                  <div className="bg-white rounded-xl p-6 shadow-md">
                    <div className="flex items-center mb-3">
                      <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                        <i className="ri-calendar-check-fill text-2xl text-purple-600"></i>
                      </div>
                      <h4 className="text-lg font-bold text-gray-900">Copertura Completa</h4>
                    </div>
                    <p className="text-gray-600">
                      Protezione garantita fino alla prima scadenza contrattuale, senza bisogno di rinnovi.
                    </p>
                  </div>

                  <div className="bg-white rounded-xl p-6 shadow-md">
                    <div className="flex items-center mb-3">
                      <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                        <i className="ri-calculator-fill text-2xl text-orange-600"></i>
                      </div>
                      <h4 className="text-lg font-bold text-gray-900">Preventivo Personalizzato</h4>
                    </div>
                    <p className="text-gray-600">
                      Il costo esatto viene calcolato in base al canone mensile e alla tipologia di immobile.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 text-center">
                <Button size="lg" className="inline-flex items-center bg-blue-600 text-white font-semibold px-8 py-4 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap" onClick={() => setShowBooking(true)}>
                  <i className="ri-file-list-3-fill mr-2 text-xl"></i>
                  Richiedi il Tuo Preventivo Gratuito
                </Button>
              </div>
            </div>
          </div>
        </section>

        {/* Casi d'Uso */}
        <section className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Quando Attivare la Polizza
              </h2>
              <p className="text-xl text-gray-600">
                Situazioni in cui la polizza ti protegge
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white rounded-xl p-8 shadow-lg">
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-alert-fill text-2xl text-red-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Inquilino Moroso
                    </h3>
                    <p className="text-gray-600">
                      L'inquilino smette di pagare l'affitto. La polizza copre fino a 12 mesi 
                      di canone non pagato mentre procedi con lo sfratto.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg">
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-hammer-fill text-2xl text-orange-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Danni all'Immobile
                    </h3>
                    <p className="text-gray-600">
                      L'inquilino lascia l'immobile danneggiato. La polizza rimborsa fino a 
                      3 mensilità per riparazioni e ripristino.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg">
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-building-fill text-2xl text-yellow-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Spese Condominiali
                    </h3>
                    <p className="text-gray-600">
                      L'inquilino non paga le spese condominiali. La polizza copre gli arretrati 
                      fino a 3 mensilità di canone.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-xl p-8 shadow-lg">
                <div className="flex items-start mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-gavel-fill text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">
                      Procedura di Sfratto
                    </h3>
                    <p className="text-gray-600">
                      Necessità di avviare lo sfratto per morosità. La polizza copre fino a 
                      €2.000 di spese legali e giudiziarie.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Finale */}
        <section className="py-20 bg-blue-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-shield-check-fill text-3xl text-red-600"></i>
            </div>
            <h2 className="text-3xl font-bold text-white mb-4">
              Proteggi il Tuo Investimento Immobiliare
            </h2>
            <p className="text-xl text-red-100 mb-8">
              Non rischiare di perdere mesi di affitto. Attiva subito la polizza morosità 
              e dormi sonni tranquilli.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Button variant="secondary" size="lg" className="cursor-pointer whitespace-nowrap" onClick={() => setShowBooking(true)}>
                <span className="flex items-center">
                  <i className="ri-calendar-check-fill mr-2"></i>
                  Prenota Videoconferenza Gratuita
                </span>
              </Button>
              <Button variant="outline" size="lg" className="cursor-pointer whitespace-nowrap bg-transparent text-white border-white hover:bg-white hover:text-red-600" onClick={scrollToContact}>
                <span className="flex items-center">
                  <i className="ri-phone-fill mr-2"></i>
                  Contattaci
                </span>
              </Button>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <BookingCalendar isOpen={showBooking} onClose={() => setShowBooking(false)} />
    </div>
  );
}